import { render, staticRenderFns } from "./PostPaidConfirmation.vue?vue&type=template&id=d666dec0"
import script from "./PostPaidConfirmation.vue?vue&type=script&lang=js"
export * from "./PostPaidConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports